// extracted by mini-css-extract-plugin
export default {"minimumPaymentsHighlights":"CustomiseOffer_minimumPaymentsHighlights","loanAmountSelection":"CustomiseOffer_loanAmountSelection","inputTooltip":"CustomiseOffer_inputTooltip"};